import React from 'react';
import { motion } from 'framer-motion';
interface StatsCardProps {
  title: string;
  value: string | number;
  subtitle: string;
  icon: React.ReactNode;
  delay?: number;
}
export function StatsCard({
  title,
  value,
  subtitle,
  icon,
  delay = 0
}: StatsCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay,
    duration: 0.4
  }} className="bg-white rounded-2xl p-6 border border-mist shadow-sm" data-id="element-633">
      <div className="flex items-start justify-between mb-4" data-id="element-634">
        <div className="w-12 h-12 bg-sand rounded-xl flex items-center justify-center text-sage" data-id="element-635">
          {icon}
        </div>
      </div>
      <div data-id="element-636">
        <h3 className="text-stone text-sm font-semibold uppercase tracking-wider mb-1" data-id="element-637">
          {title}
        </h3>
        <div className="font-display text-3xl font-bold text-earth mb-1" data-id="element-638">
          {value}
        </div>
        <p className="text-stone/70 text-sm" data-id="element-639">{subtitle}</p>
      </div>
    </motion.div>;
}